import React from 'react';
import PropTypes from 'prop-types';
import './Label.scss';
import Icon from '../Icon/Icon';
import { createClassList } from '../../utils/dom/class';

/** The Label component is the same label that is applied to input components. It has been made
 * available to be used with custom elements. Pass the id of the element being labelled to the
 * 'labelForId' prop.
 */

const Label = ({
  error,
  hideLabel,
  label,
  labelForId,
  labelModifier,
  ariaLabel,
  className,
  classes,
  labelClickHandler,
}) => {
  let requiredClasses = [];

  if (error) {
    requiredClasses = [...requiredClasses, 'input-label--error'];
  }
  if (hideLabel) {
    requiredClasses = [...requiredClasses, 'input-label--hidden'];
  }

  function validateLabel() {
    if (!label.trim()) {
      throw new Error(
        'Empty label not valid, label must contain actual text.'
      );
    }
    return label;
  }

  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events  */
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */
    <label
      htmlFor={labelForId}
      className={createClassList({
        default: ['axiom-input-label input-label', `${className || ''}`], // Note: className prop included to avoid breaking change
        custom: classes,
        required: requiredClasses,
      })}
      aria-label={ariaLabel}
      onClick={labelClickHandler}
    >
      {error && <Icon name='notice-error' />}
      {labelModifier === 'required' ? '* ' : ''}
      {validateLabel()}
      {labelModifier === 'optional' ? (
        <span className='input-label--optional'>{' (Optional)'}</span>
      ) : (
        ''
      )}
    </label>
  );
};

Label.propTypes = {
  labelForId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelModifier: PropTypes.oneOf(['required', 'optional']),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hideLabel: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  labelClickHandler: PropTypes.func,
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Label.defaultProps = {
  labelModifier: null,
  error: undefined,
  hideLabel: false,
  ariaLabel: undefined,
  className: undefined,
  labelClickHandler: undefined,
  classes: [],
};

export default Label;
